const SvgAboutHeroBottom = (props) => (
  <svg viewBox="0 0 786 213" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M384.003 36.4751V213H560.102L384.003 36.4751Z" fill="#EFAC26" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M573.619 101.474C562.847 112.231 547.965 118.884 531.526 118.884C498.65 118.884 471.998 92.2712 471.998 59.4422C471.998 43.0278 478.661 28.1673 489.433 17.4104L573.619 101.474Z"
      fill="#363636"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M524.055 118.42C494.707 114.748 472.002 89.7429 472.002 59.442C472.002 26.6131 498.654 0 531.53 0C564.407 0 591.059 26.6131 591.059 59.442C591.059 75.8556 584.396 90.7154 573.625 101.472L489.441 17.4107C478.669 28.1675 472.006 43.028 472.006 59.4425C472.006 89.7421 494.709 114.747 524.055 118.42Z"
      fill="#F2D6BB"
    />
    <rect
      width="72.9457"
      height="72.9457"
      transform="matrix(-0.707633 0.70658 0.707633 0.70658 130.5 109.836)"
      fill="#D0AE86"
    />
    <ellipse rx="44.366" ry="44.3016" transform="matrix(-1 0 0 1 646.368 168.117)" fill="#F06C22" />
    <ellipse rx="29.5" ry="29.4561" transform="matrix(-1 0 0 1 29.5 183.227)" fill="#F2D6BB" />
    <path d="M737.652 137.795L691 212.683H786L737.652 137.795Z" fill="#3763FF" />
    <path
      d="M383.766 36.7422L330.887 89.5415C321.853 80.5202 309.381 74.9304 295.58 74.9304C268.004 74.9304 245.639 97.2622 245.639 124.796V174.662L207.394 212.851V36.7422H383.766Z"
      fill="#BC6038"
    />
    <path d="M207.394 212.852H383.766L345.52 174.663H245.639L207.394 212.852Z" fill="#3763FF" />
    <path
      d="M330.887 89.5415L383.766 36.7422V212.851L345.52 174.662V124.796C345.52 111.043 339.922 98.5628 330.887 89.5415Z"
      fill="#3763FF"
    />
  </svg>
);

export default SvgAboutHeroBottom;
